module.exports = __webpack_public_path__ + "img/progress_089.9c41946d.png";